import general from './general.json';

export default {
  ...general,
};
